import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import PaymentRedirectView from 'src/views/PaymentRedirect';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true,
    skipSplash: true
  }
}));
export default PaymentRedirectView;